import { Checkbox, Icon } from 'antd';
import React, { Component } from 'react';
import { isArray } from 'util';

class Row extends Component {
    render() {
        const { data, keyRow } = this.props
        let type_text 
        let class_disable_status
        if (data.type === 'NEW') {
            type_text = "ADD"
            class_disable_status = '';
        } else {
            if (!data.checkedMap) {
                type_text = "No-UPDATE"
                class_disable_status = 'disable'
            } else {
                type_text = "UPDATE"
                class_disable_status = ''
            }
        }
        return (
            <React.Fragment>
                <tr className={keyRow % 2 === 0 ? 'tr-even' : ''}>
                    <td className='checkbox'>
                        <Checkbox
                            onChange={e => this.props.checked(e.target.checked, data.sku)}
                            checked={data.checkedMap}
                        />
                    </td>
                    <td className='key'>{keyRow}</td>
                    <td className={'status ' + class_disable_status}><span className={'key-row-item-name '
                        + (data.type === 'NEW' ? 'create-new-item-name' : 'update-item-name')}
                    >{type_text}</span></td>
                    <td className='sku'>{data.sku}</td>
                    <td className='item-code-mapping'>{data.item_code}</td>
                    <td className='item-name-mapping'>{data.item_name}</td>
                    <td className='item-waring-prohibite-mapping'>
                        {
                            isArray(data.ProhibitedKeyWord) && data.ProhibitedKeyWord.length > 0 ? 
                                <span className={data.HasApproveKeyWordBL ? "box-rectangle box-rectangle-disable" : "box-rectangle"}><Icon type="exclamation"></Icon></span>
                            : ''
                        }
                    </td>
                    <td className='origin-mapping'>{data.origin}</td>
                </tr>
                {data.type === 'UPD' && (
                    <tr className={keyRow % 2 === 0 ? 'tr-even' : ''}>
                        <td className='checkbox'></td>
                        <td className='key'></td>
                        <td className='status status-current'><span className={'key-row-item-name'}>Current</span></td>
                        <td className='sku'>{data.sku}</td>
                        <td className='item-code-mapping'>{data.item_code_mapping}</td>
                        <td className='item-name-mapping'>{data.item_name_mapping} </td>
                        <td className='item-waring-prohibite-mapping'>
                            {
                                isArray(data.ProhibitedKeyWordMapping) && data.ProhibitedKeyWordMapping.length > 0 ? 
                                    <span className={data.HasApproveKeyWordBLMapping ? "box-rectangle box-rectangle-disable" : "box-rectangle"}><Icon type="exclamation"></Icon></span>
                                : ''
                            }
                        </td>
                        <td className='origin-mapping'>{data.origin_mapping}</td>
                    </tr>
                )}
            </React.Fragment>

        );
    }
}

export default Row;


// WEBPACK FOOTER //
// ./src/containers/orders/components/translation-item-name/Row.js